// Mapeo de URLs amigables para categorías
export const categoryUrlMapping = {
  'etiquetado': 'accesorios',
  'accesorios': 'etiquetado',
  'pesaje-dinamico': 'sistemas-pesaje',
  'sistemas-pesaje': 'pesaje-dinamico',
  'basculas-colgar': 'basculas-de-colgar',
  'masas-patrones': 'masas-patrones',
  'celdas-cargas': 'celdas-de-cargas',
  'balanzas-pedestal-packing': 'balanzas-de-pedestal-packing'
};

// Mapeo inverso para convertir URL amigable a ID interno
export const reverseCategoryUrlMapping = {
  'accesorios': 'etiquetado',
  'etiquetado': 'accesorios',
  'sistemas-pesaje': 'pesaje-dinamico',
  'pesaje-dinamico': 'sistemas-pesaje',
  'basculas-de-colgar': 'basculas-colgar',
  'masas-patrones': 'masas-patrones',
  'celdas-de-cargas': 'celdas-cargas',
  'balanzas-de-pedestal-packing': 'balanzas-pedestal-packing'
};

// Configuración de rutas dinámicas
export const routes = {
  home: '/',
  productos: '/productos',
  productosCategoria: (categoryId) => {
    // Mapear ID interno a URL amigable
    const urlSlug = categoryUrlMapping[categoryId] || categoryId;
    return `/productos/${urlSlug}`;
  },
  productosDetalle: (categoryId, productSlug) => {
    // Mapear ID interno a URL amigable
    const urlSlug = categoryUrlMapping[categoryId] || categoryId;
    return `/productos/${urlSlug}/${productSlug}`;
  },
  servicios: '/servicios',
  contacto: '/contacto'
};

// Función para generar URLs amigables
export const generateSEOUrl = (text) => {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remover acentos
    .replace(/[^a-z0-9\s-]/g, '') // Solo letras, números, espacios y guiones
    .replace(/\s+/g, '-') // Reemplazar espacios con guiones
    .replace(/-+/g, '-') // Múltiples guiones a uno solo
    .trim();
};

// Función para validar si una URL es válida
export const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

// Función para generar slug único para productos
export const generateProductSlug = (product) => {
  const baseSlug = generateSEOUrl(product.nombre);
  // Agregar ID para asegurar unicidad
  return `${baseSlug}-${product.id}`;
};

// Función para extraer ID del slug
export const extractProductIdFromSlug = (slug) => {
  const match = slug.match(/-(\d+)$/);
  return match ? parseInt(match[1]) : null;
};

// Función para obtener parámetros de la URL
export const getUrlParams = (pathname) => {
  const segments = pathname.split('/').filter(Boolean);
  const urlCategoryId = segments[1] || null;
  
  // Convertir URL amigable de vuelta al ID interno
  const categoryId = reverseCategoryUrlMapping[urlCategoryId] || urlCategoryId;
  
  return {
    categoryId: categoryId,
    productSlug: segments[2] || null
  };
}; 